//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      locals: {
        OrderId: null,
        CurrencyRateFrom: null,
        CurrencyRateTo: null,
        AtmId: null,
        TransferId: null,
      },
      filters: {
        OrderId: null,
        OrderTypeName: null,
        OrderStatusName: null,
        TransferId: null,
        OrgName: null,
        BaseCurrencyName: null,
        QuoteCurrencyName: null,
        CurrencyRateFrom: null,
        CurrencyRateTo: null,
        AtmId: null,
        DateCreatedFrom: null,
        DateCreatedTo: null,
      },
      constant,
    };
  },

  computed: {
    ...mapState('cryptomatsOrders', {
      filterLists: 'filters',
    }),
    ...mapState('cryptomatsRenters', ['rentersList', 'rentersNames']),
    ...mapState('tradersCurrencies', { currencies: 'data' }),
  },

  watch: {
    filters: {
      handler: _.debounce(function (data) {
        this.setFilters(data);
        this.$emit('update');
      }, 500),
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('cryptomatsOrders', [
      'setFilters',
    ]),

    clickManualHandler() {
      this.filters.OrderStatusName = this.filters.OrderStatusName === constant.cryptomats.STATUSES.AWAITING ? '' : constant.cryptomats.STATUSES.AWAITING;
    },

    handleLocalValue(key, value) {
      this.filters[key] = value;
    },
  },
};
